<script setup lang="ts">
const { chosenPlace, places } = usePlaces()
</script>

<template>
  <main>
    <section class="bg-neutral-700 py-10 text-white">
      <div class="container">
        <h2 class="mb-10 text-center text-3xl font-medium">Kontakty</h2>
        <div
          class="mx-auto mb-10 grid w-fit grid-cols-1 justify-items-stretch gap-5 lg:grid-cols-2"
        >
          <div
            class="flex w-full max-w-lg flex-col gap-10 rounded-3xl bg-neutral-500 p-5 px-10"
          >
            <div class="flex items-center justify-between gap-10">
              <p>Zavolejte nám ZDARMA:</p>
              <NuxtLink href="tel:800911911">
                <button
                  class="flex items-center gap-2 rounded-full bg-sky-600 px-4 py-2 text-sm font-medium text-white"
                >
                  <Icon name="fa6-solid:phone" />
                  800 911 911
                </button>
              </NuxtLink>
            </div>
            <div class="flex items-center justify-between gap-10">
              <div>
                <p>Technická podpora</p>
                <p>HOTLINE 24/7:</p>
                <p>
                  E-mail:
                  <NuxtLink href="mailto:hotline@grapesc.cz">
                    <span class="font-extralight">hotline@grapesc.cz</span>
                  </NuxtLink>
                </p>
              </div>
              <NuxtLink href="tel:800911911">
                <button
                  class="flex items-center gap-2 rounded-full bg-sky-600 px-4 py-2 text-sm font-medium text-white"
                >
                  <Icon name="fa6-solid:phone" />
                  800 911 911
                </button>
              </NuxtLink>
            </div>
          </div>
          <div
            class="flex w-full max-w-lg flex-col gap-5 rounded-3xl bg-neutral-500 p-5 px-10 text-center"
          >
            <div>
              <p class="font-bold">Firemní zákazníci</p>
              <p class="font-extralight">
                pro nabídku kontaktujte naše obchodní oddělení
              </p>
            </div>
            <div>
              <p class="font-extralight">
                <span class="font-bold">Email:</span>
                <NuxtLink href="mailto:obchod@grapesc.cz">
                  obchod@grapesc.cz
                </NuxtLink>
              </p>
            </div>
            <div>
              <p class="font-bold">Fakturace</p>
              <p class="font-extralight">
                <span class="font-bold">Email:</span>
                <NuxtLink href="mailto:fakturace@grapesc.cz">
                  fakturace@grapesc.cz
                </NuxtLink>
              </p>
            </div>
          </div>
        </div>
        <button
          class="mx-auto mb-10 block w-fit gap-2 rounded-full bg-sky-600 px-4 py-2 text-sm font-medium text-white"
        >
          Další kontakty
        </button>
        <div
          class="mx-auto mb-10 grid w-fit grid-cols-1 justify-items-stretch gap-5 lg:grid-cols-2"
        >
          <div
            class="flex max-w-lg flex-col gap-5 rounded-3xl bg-neutral-500 p-5 px-10 text-center text-white"
          >
            <div>
              <p class="font-bold">Korespondenční adresa</p>
              <p class="font-extralight">
                GRAPE SC, a.s., Volyňských Čechů 837 438 01 Žatec
              </p>
            </div>
            <div>
              <p class="font-bold">Sídlo společnosti</p>
              <p class="font-extralight">
                Karlovo náměstí 559/28, Nové Město 120 00 Praha 2
              </p>
            </div>
            <div class="flex justify-center gap-2">
              <p class="font-extralight">
                <span class="font-bold">IČO:</span>
                25708783,
              </p>
              <p class="font-extralight">
                <span class="font-bold">DIČ:</span>
                CZ25708783
              </p>
            </div>
            <NuxtLink to="#" class="underline">
              Výpis z obchodního rejstříku
            </NuxtLink>
            <div>
              <p class="font-extralight">
                <span class="font-bold">ID datové schránky:</span>
                draebn8
              </p>
            </div>
            <div>
              <p class="font-bold">Bankovní spojení</p>
              <p class="font-extralight">
                22000247/0100 Komerční banka, a.s. Chomutov
              </p>
            </div>
            <div>
              <p class="font-extralight">
                <span class="font-bold">Telefon:</span>
                <NuxtLink href="tel:800911911">800 911 911</NuxtLink>
              </p>
              <p class="font-extralight">
                <span class="font-bold">E-mail:</span>
                <NuxtLink href="mailto:info@grapesc.cz">
                  info@grapesc.cz
                </NuxtLink>
              </p>
            </div>
          </div>
          <div
            class="flex w-full max-w-lg flex-col gap-5 rounded-3xl bg-neutral-500 p-5 px-10 text-center"
          >
            <div>
              <p class="font-bold">
                Vyřizování pohledávek:
                <NuxtLink href="mailto:pohledavky@grapesc.cz">
                  pohledavky@grapesc.cz
                </NuxtLink>
              </p>
            </div>
            <div class="mx-auto max-w-xs">
              <p class="break-words font-extralight">
                <span class="font-bold">E-mail:</span>
                <NuxtLink href="mailto:pohledavky@grapesc.cz">
                  pohledavky@grapesc.cz
                </NuxtLink>
              </p>
            </div>
            <div>
              <p class="font-bold">Vyjádření k existenci sítí</p>
              <p class="font-extralight">
                <span class="font-bold">E-mail:</span>
                <NuxtLink href="mailto:projekce@grapesc.cz">
                  projekce@grapesc.cz
                </NuxtLink>
              </p>
              <p class="font-extralight">
                <span class="font-bold">Elektronická žádost:</span>
                <NuxtLink external to="http://projekce.grapesc.cz/CBYD">
                  projekce
                </NuxtLink>
              </p>
            </div>
            <NuxtLink to="/vyjadreni-k-existenci-siti" class="underline">
              Ceník a požadované doklady
            </NuxtLink>
            <div>
              <p class="font-bold">
                Institut změny poskytovatele služby Internet
              </p>
              <p class="font-extralight">
                <span class="font-bold">E-mail:</span>
                <NuxtLink href="mailto:transfer@grapesc.cz">
                  transfer@grapesc.cz
                </NuxtLink>
              </p>
            </div>
            <NuxtLink
              to="/pdf/prenositelnost.pdf"
              target="_blank"
              external
              class="underline"
            >
              Více informací zde
            </NuxtLink>
            <div>
              <p class="font-extralight">
                * OKU kód naleznete v zákaznické zóně
              </p>
            </div>
          </div>
        </div>

        <h2 class="mb-10 text-center text-3xl font-medium">Pobočky</h2>

        <div class="mx-auto mb-10 flex w-fit gap-5 max-lg:flex-col">
          <BranchOffices />
          <div
            class="col-span-1 flex flex-col gap-5 rounded-3xl bg-neutral-500 p-5 text-center"
          >
            <template v-for="place in places">
              <iframe
                v-if="place.name === chosenPlace"
                :src="place.googleSrc"
                width="600"
                height="450"
                style="border: 0"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
                class="aspect-square h-auto w-full rounded-3xl"
              ></iframe>
            </template>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
